import { Block, CRRender } from '@/components/crRender';
import { Checkbox } from '@/components/Exporter';
import { HOSPITAL_STATUS, HOSPITAL_STATUS_COLOR } from '@/data/hospitalStatus';
import { PROVIDER_REQUEST_STATUS, PATIENT_REQUEST_STATUS, STATUS_MAP } from '@/data/status';
import { formatDate } from '@/utils/dateUtils';
import { translate } from '@/utils/langUtils';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

const DataTable = ({ setSelectedHospital, orderStatusId, setOpednedFiles, setIsChatOpen, availableProviders }: any) => {
    const { medicalOrderId } = useParams();
    const { i18n } = useTranslation();
    const [selectedProvider, setSelectedProvider] = useState<any>(null);

    useEffect(() => {
        if (!availableProviders) return;
        let selectedProvider = availableProviders?.find((ele: any) => ele.isSelected) || null;
        handleHospitalSelect(selectedProvider);
    }, [availableProviders]);

    const handleHospitalSelect = (hospital: any) => {
        setSelectedProvider(hospital);
        setSelectedHospital(hospital);
    };

    const isAvilableToSelect = useMemo(() => STATUS_MAP.QuotationAvailable == orderStatusId, []);


    return (
        <div className="rd-table-wrapper">
            <table className="rd-table">
                <thead>
                    <tr>
                        <CRRender isRender={isAvilableToSelect}>

                            <th className="rd-th-checkbox"></th>
                        </CRRender>
                        <th>{translate("Required Hospitals")}</th>
                        <th>{translate("Prices")}</th>
                        <th>{translate("Prices-details")}</th>
                        <th>{translate("Request Date")}</th>
                        <th>{translate("Hospital respond")}</th>
                        <th>{translate("Hospital comment")}</th>
                    </tr>
                </thead>
                <tbody>
                    {availableProviders?.map((hospital: any) =>
                        <tr key={hospital.id} className={selectedProvider?.id === hospital.id ? "rd-row-selected" : ""}>

                            <CRRender isRender={isAvilableToSelect}>
                                <td className="rd-td-checkbox">
                                    <Checkbox
                                        value={ selectedProvider?.id == hospital.id}
                                        itemsList={selectedProvider?.id}
                                        onApply={() => handleHospitalSelect(hospital)}
                                        isDisabled={hospital?.isSelected}
                                        className="relative-checkbox"
                                    />
                                </td>
                            </CRRender>
                            <td>{hospital.name}</td>
                            <td className="rd-price">
                                {!!hospital.price ? `$${hospital.price.toLocaleString()}` : "-"}
                            </td>
                            <td>
                                <Block isRender={!!hospital.price} >
                                    <Link
                                        to={`/panel/broker/medical-requests/${medicalOrderId}/quotation/${hospital.id}`}
                                        state={{ hospitalId: hospital.id, hospitalPrice: hospital.price }}
                                        className="rd-file-link"
                                    >
                                        {translate("show-prices-details")} <Icon icon={`prime:arrow-${i18n.language === "en" ? "left" : "right"}`} width={20} height={20} />
                                    </Link>
                                </Block>
                            </td>
                            <td>
                                {hospital.providerResponseDate ? formatDate(hospital.providerResponseDate) : "-"}
                            </td>
                            <td>
                                <span className={`rd-respond-badge ${HOSPITAL_STATUS_COLOR[hospital.statusId]}`} >
                                    {translate(hospital.statusName)?.toUpperCase()}
                                </span>
                            </td>
                            <td>
                                {
                                    hospital.statusId == HOSPITAL_STATUS.InformationRequested ? (
                                        <span className='cta-click img' onClick={() => { setIsChatOpen(true); setOpednedFiles(hospital.id); }}>{translate("click-to-view")}</span>
                                    ) : "--"
                                }
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default DataTable